import React from 'react';
export function SectionDivider() {
  return <div className="w-full flex items-center justify-center py-4 px-4 opacity-80" data-id="element-313">
      <div className="h-[1px] w-full max-w-[120px] bg-brand-cyan/30" data-id="element-314"></div>
      <span className="text-brand-cyan/60 text-[10px] mx-4" data-id="element-315">◆</span>
      <div className="h-[1px] w-full max-w-[120px] bg-brand-cyan/30" data-id="element-316"></div>
    </div>;
}